import componentShell from "./shell"
import Uploader from "@/uploader/components/uploader"

export default componentShell(Uploader)
